import { showToast } from '@/utils'
import { Countries } from '@/utils/countries'
import type { Waypoint } from '@apiTypes'

export interface ValidationResult {
  errors: string[]
  warnings: string[]
}

export interface AddressCheckResult {
  pickup: ValidationResult
  delivery: ValidationResult
  global: ValidationResult
}

export function areAddressesUnique(...addresses: Array<Waypoint | undefined>) {
  if (!addresses?.length)
    return true

  const addressesCoordinates = addresses.map(address => address?.point?.coordinates?.toString())

  // Skip uniqueness validation while addresses are incomplete.
  if (addressesCoordinates.some(coordinates => !coordinates))
    return true

  return new Set(addressesCoordinates).size === addressesCoordinates.length
}

export function isDisallowedCountry(address?: Waypoint) {
  const country = address?.country

  if (!country)
    return false

  return !Countries.includes(country)
}

export function collectAndShowMessages(addressCheckResult: AddressCheckResult) {
  Object.values(addressCheckResult).forEach((entry: ValidationResult) => {
    entry.errors.forEach(error => showToast(error, 'error'))
    entry.warnings.forEach(warning => showToast(warning, 'warning'))
  })
}
